module.exports = __webpack_public_path__ + "static/media/animal-cow1.19652ae5.aac";